import { Injectable } from '@angular/core';
import { TokenAbstractService } from '../../abstract/token-abstract.service';
import { LegacyDecodedJWT, LegacyLoginResponse } from '../../../../models';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LegacyTokenHandler extends TokenAbstractService {
  protected override readonly tokenStorageKey = 'auth_token';

  setToken({ access_token }: LegacyLoginResponse): void {
    if (access_token) {
      this.localStorageService.store(this.tokenStorageKey, access_token);
    }
  }

  getValidToken(): Observable<string | null> {
    const token = this.retrieveToken<string>();

    return of(token && !this.isTokenExpired(token) ? token : null);
  }

  getWebsiteId(): number | null {
    const token = this.retrieveToken<string>();
    return token ? +this.decodeJWT<LegacyDecodedJWT>(token).WebsiteId : null;
  }

  getEmail(): string | null {
    const token = this.retrieveToken<string>();
    if (!token) {
      return null;
    }
    const [userEmailOrImpersonatedId, userEmail] = this.decodeJWT<LegacyDecodedJWT>(token).unique_name;
    return userEmailOrImpersonatedId || userEmail;
  }

  getRole(): string | string[] | null {
    const token = this.retrieveToken<string>();
    return token ? this.decodeJWT<LegacyDecodedJWT>(token).role : null;
  }

  getUserId(): string | null {
    const token = this.retrieveToken<string>();
    return token ? this.decodeJWT<LegacyDecodedJWT>(token).nameid : null;
  }
}
